import React, { useState, useEffect, useRef } from 'react';
import { Search } from '@sainsburys-tech/luna-icons'
import { Table } from '@sainsburys-tech/luna-table';
import { Modal } from '@sainsburys-tech/luna-modal';
import { Pagination } from '@sainsburys-tech/luna-pagination';
import { Link } from "react-router-dom";
import { Card, FilledButton, GridItem, FormGroup, SearchInput, GridWrapper, BreadcrumbsWrapper, BreadcrumbsItem, Footer } from '@sainsburys-tech/luna-react';
import { Select, SelectField } from "@sainsburys-tech/luna-form";

import { BranchLocatorFilter, DDLBinding, BLocatorType, BLType, BranchLocatorUserInfo, DDBLBinding, RetailAndLogisticsContactModel } from '../../types/Entities/BranchLocator';
// import getbranchlocatorsiteinfo from '../../api/branchLocatorApi';
import { useApiClient } from '../../context/AppContext';
// import { DDLBinding, FMRegionDetail, ZoneSearchItem } from '../../types/Entities/SiteCareManager'
// import siteCareManagerAPi from '../../api/siteCareManagerApi'
import getbranchlocatorapi from '../../api/branchLocatorApi';

const BranchLocator = () => {
  const apiClient = useApiClient();
  const isFirstRender = useRef(true);
  const scrollToTop = () => document.querySelector('div.table-scrollable')?.scrollTo(0, 0)

  const [isOpen, setIsOpen] = useState(false);
  const [loader, setLoader] = useState(false)
  const [url, setUrl] = useState("")

  const recordsPerPage = 20;
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState<number>();
  const [searchItem, setSearchItem] = useState<string>("")

  const [blData, setBLData] = useState<BLocatorType>({} as BLocatorType);
  const [selectedSite, setSelectedSite] = useState<BranchLocatorUserInfo[] | null>();
  const [allSiteArray, setAllSiteArray] = useState<BranchLocatorUserInfo[]>([]);
  // const [fmzonedetails, setzonedetails] = useState([] as ZoneSearchItem[])
  // const [fmregiondetails, setfmregiondetails] = useState([] as FMRegionDetail[])
  // const [dmdetails, setdmdetails] = useState([] as DDLBinding[])
  // const [deliveryManagerdetails, setdeliveryManagerdetails] = useState([] as ZoneSearchItem[])
  const [zonedropdown, setzonedropdown] = useState('')
  // const [selectedZone, setSelectedZone] = useState('');
  const [regiondropdown, setregiondropdown] = useState('')
  const [dmdropdown, setdmdropdown] = useState('')
  const [bpdropdown, setbpdropdown] = useState('')
  const [errorAlert, setErrorAlert] = useState<false | string>(false)
  const [showFilters, setShowFilters] = useState(false);

  const [dmDDOptions, setDmDDOptions] = useState([] as DDBLBinding[])
  const [zoneDDOptions, setZoneDDOptions] = useState([] as DDLBinding[])
  const [regionDDOptions, setRegionDDOptions] = useState([] as DDBLBinding[])
  const [businessPartnerDDOptions, setBusinessPartnerDDOptions] = useState([] as DDBLBinding[])

  const toggleFilters = () => {
    setShowFilters((prev) => !prev)
    if(showFilters){
      setdmdropdown('');
      setzonedropdown('');
      setregiondropdown('');
      // setSelectedZone('');
      setbpdropdown('')
    }
  };

  const fetchBranchLocatorData = async (startIndex?: number, pageSize?: number, searchItemText?: string) => {
    setLoader(true);
    const filter: BranchLocatorFilter = {
      StartIndex: startIndex ? startIndex : 0,
      PageSize: pageSize ? pageSize : recordsPerPage,
      SearchTerm: searchItemText ? "" : searchItem,
      DMName: dmdropdown ? dmdropdown : "",
      ZoneName: zonedropdown ? zonedropdown : "",
      RegionName: regiondropdown ? regiondropdown : "",
      BusinessPartnerName: bpdropdown ? bpdropdown : ""
    };
    if (!startIndex) {
      setCurrentPage(1)
    }

    try {
      const res = await getbranchlocatorapi.getbranchlocatorsiteinfo(apiClient, filter);
      setTotalRecords(res.recordsCount);
      setBLData(res);
    } catch (error) {
      console.error('Error fetching branch locator data:', error);
    }
    scrollToTop();
  };

  const callBranchLocatorData = async (startIndex: number, pageSize: number) => {
    fetchBranchLocatorData(startIndex, recordsPerPage)
      .then(() => {
        setLoader(false);
        scrollToTop();
      })
  }

  const fetchSiteDetails = async () => {
    try {
      const resp = await getbranchlocatorapi.getbranchlocatoruserinfo(apiClient);
      const siteInfo = resp.blUserInfo;
      if (siteInfo) {
        setAllSiteArray(siteInfo);
      } else {
        setAllSiteArray([]);
      }
    }
    catch (error) {
      console.error('Error fetching site details:', error);
    }
  };


  const handleSelectedSite = async (payload: string, siteName: string) => {
    const payloadText = payload.replace(/\D/g, '') // it will replace all the Characters from the string with '' empty character
    setLoader(true);
    const filterSelectedSite = allSiteArray.filter((x: BranchLocatorUserInfo) => x.verisaeSiteID === payload)
    setSelectedSite(filterSelectedSite.length > 0 ? filterSelectedSite : []);
    if (filterSelectedSite.length > 0) {
      handleNavigation(payloadText.length == 3 ? '0' + payloadText : payloadText, siteName)
        .then(() => setLoader(false));
    } else {
      setLoader(false)
    }
    setIsOpen(true);
  }

  const handleNavigation = async (payload: string, verifySiteName: string) => {
    getbranchlocatorapi.getStores(apiClient, payload)
      .then((res: any) => {
        if (res.Result) {
          const targetUrl = res.Result;
          const verifyPath = targetUrl.split("/")
          if (verifyPath.length > 3) {
            const xx = verifyPath[4].split("-")[0]
            const yy = verifySiteName.split(" ")[0]
            setUrl(xx.toLocaleLowerCase() === yy.toLocaleLowerCase() ? targetUrl : "")
          }
        }
      })
  }

  const handleKeyDown = (event: { key: string; }) => {
    if (event.key === 'Enter') {
      fetchBranchLocatorData()
        .then(() => setLoader(false))
    }
  };

  const handleSearchItem = (value: string) => {
    setSearchItem(value);
    if (value === "") {
      fetchBranchLocatorData(0, recordsPerPage, "performing onClear event")
        .then(() => setLoader(false))
    }
  }

  const getUnique = <T,>(arr: T[], keyFn: (item: T) => string | undefined): T[] => {
    const seen = new Set<string>();
    return arr.filter(item => {
      const key = keyFn(item);
      if (!key || seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  };
  
  const fetchAllRegionDetails = async () => {
    try {
      const res: RetailAndLogisticsContactModel[] = await getbranchlocatorapi.getAllRegionDetails(apiClient);
      const temp_DmDDOptions: DDBLBinding[] = res.map(item => ({
          label: item.name,
          value: item.name,
          zone: item.zone,
          region: item.region,
          businessPartner: item.scmUser.name
        })).filter(item => item.label != null)
        .sort((a, b) => a.label.localeCompare(b.label));

      const temp_BusinessPartnerDDOptions: DDBLBinding[] = res
        .map(item => ({
          label: item.scmUser.name,
          value: item.scmUser.name,
          zone: item.zone,
          region: item.region
        })).filter(item => item.label != null)
        .sort((a, b) => a.label.localeCompare(b.label));

      const temp_RegionDDOptions: DDBLBinding[] = res
        .map(item => ({
          label: item.region,
          value: item.region,
          zone: item.zone,
        })).filter(item => item.label != null)
        .sort((a, b) => a.label.localeCompare(b.label));

      const temp_ZoneDDOptions: DDLBinding[] = res
        .map(item => ({
          label: item.zone,
          value: item.zone,
        })).filter(item => item.label != null)
        .sort((a, b) => a.label.localeCompare(b.label));

        setDmDDOptions(temp_DmDDOptions);
        setBusinessPartnerDDOptions(temp_BusinessPartnerDDOptions);
        setRegionDDOptions(temp_RegionDDOptions);
        setZoneDDOptions(temp_ZoneDDOptions);
    } catch (error) {
      console.error('Error fetching region details:', error);
    }
  };

  const fmZoneChangeEvent = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const zoneValue = event.target.value;
    setzonedropdown(zoneValue);
    
    if(regiondropdown && !(regionDDOptions.find(rg => (rg.label == regiondropdown) && (rg.zone == zoneValue)))){
      setregiondropdown("")
    }
    if(dmdropdown && !(dmDDOptions.find(rg => (rg.label == dmdropdown) && (rg.zone == zoneValue)))){
      setdmdropdown("")
    }
    if(bpdropdown && !(businessPartnerDDOptions.find(rg => (rg.label == bpdropdown) && (rg.zone == zoneValue)))){
      setbpdropdown("")
    }
    
  };

  const fmRegionChangeEvent = (event: React.ChangeEvent<HTMLSelectElement>) => {
    var regionValue = event.target.value;
    setregiondropdown(regionValue);
    
    if(dmdropdown && !(dmDDOptions.find(rg => (rg.label == dmdropdown) && (rg.region == regionValue)))){
      setdmdropdown("")
    }
    if(bpdropdown && !(businessPartnerDDOptions.find(rg => (rg.label == bpdropdown) && (rg.region == regionValue)))){
      setbpdropdown("")
    }
  }

  const bpChangeEvent = (event: React.ChangeEvent<HTMLSelectElement>) => {
    var bpValue = event.target.value;
    setbpdropdown(bpValue);
    
    if(dmdropdown && !(dmDDOptions.find(rg => (rg.label == dmdropdown) && (rg.businessPartner == bpValue)))){
      setdmdropdown("")
    }
  }
  
  const dmChangeEvent = (event: React.ChangeEvent<HTMLSelectElement>) => {
    var dmValue = event.target.value;
    setdmdropdown(dmValue);

  }

  const fetchData = async () => {
    await fetchBranchLocatorData();
  };
  
  useEffect(() => {
    fetchData().then(() => setLoader(false))
    fetchSiteDetails()
    fetchAllRegionDetails();
  }, []);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return; // Skip the first render
    }

    fetchData().then(() => setLoader(false))
  }, [dmdropdown, zonedropdown, regiondropdown, bpdropdown]);

  return (
    <>
      <div className="card-container">
        <Card className="card-container1">
          <GridWrapper className="grigItem_SearchInput">
            <GridItem size={{ xl: showFilters ? "2/6" : "4/6", lg: showFilters ? "2/6" : "4/6" }}>
              <h5>Branch Locator</h5>
            </GridItem>
            <GridItem
              style={{
                width: "fit-content",
                flex: "0 0 auto",
                minWidth: 0,
                maxWidth: "none"
              }}
            >
              <button
                onClick={toggleFilters}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  padding: "8px 12px",
                  border: "none",
                  backgroundColor: "#f06c00",
                  color: "white",
                  borderRadius: "4px",
                  cursor: "pointer"
                }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style={{ stroke: "white" }}>
                  <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
                </svg>
                Filter
              </button>
            </GridItem>

            {showFilters && (
              <>
                <GridItem
                  className={`filter-slide${showFilters ? " slide-in" : ""}`}
                  size={{ xl: "1/6", lg: "1/6" }}
                >
                  <SelectField
                    name="zone"
                    placeholder="FM Zone"
                    options={getUnique(zoneDDOptions, item => item.label)}
                    value={zonedropdown}
                    onChange={fmZoneChangeEvent}
                  />
                </GridItem>
                <GridItem
                  className={`filter-slide${showFilters ? " slide-in" : ""}`}
                  size={{ xl: "1/6", lg: "1/6" }}
                >
                  <SelectField
                    name="region"
                    placeholder="FM Region"
                    options={getUnique(regionDDOptions.filter(regionDD => zonedropdown ? regionDD.zone == zonedropdown : true), item => item.label)}
                    value={regiondropdown}
                    onChange={fmRegionChangeEvent}
                  />
                </GridItem>
                <GridItem
                  className={`filter-slide${showFilters ? " slide-in" : ""}`}
                  size={{ xl: "1/6", lg: "1/6" }}
                >
                  <SelectField
                    name="businessPartnerName"
                    placeholder="Business Partner"
                    options={getUnique(businessPartnerDDOptions.filter(regionDD => (zonedropdown ? regionDD.zone == zonedropdown : true) && (regiondropdown ? regionDD.region == regiondropdown : true)), item => item.label)}
                    value={bpdropdown}
                    onChange={bpChangeEvent}
                  />
                </GridItem>
                <GridItem
                  className={`filter-slide${showFilters ? " slide-in" : ""}`}
                  size={{ xl: "1/6", lg: "1/6" }}
                >
                  <SelectField
                    name="deliveryManagerName"
                    placeholder="Delivery Manager"
                    options={getUnique(dmDDOptions
                      .filter(regionDD => (
                        (zonedropdown ? regionDD.zone == zonedropdown : true )
                        && (bpdropdown ? regionDD.businessPartner == bpdropdown : true)
                        && (regiondropdown ? regionDD.region == regiondropdown : true)
                        )),item => item.label)}
                    value={dmdropdown}
                    onChange={dmChangeEvent}
                  />
                </GridItem>
              </>
            )}

            <GridItem size={{ xl: showFilters ? "1/6" : "2/6", lg: showFilters ? "1/6" : "2/6" }}>
              <FormGroup name="workordernumber" label="">
                <SearchInput
                  name="workorder-search"
                  placeholder="e.g. 56870001"
                  onChange={(e: any) => handleSearchItem(e.target.value)}
                  onKeyDown={handleKeyDown}
                  hasAction
                  action={
                    <button onClick={(e: any) => fetchBranchLocatorData().then(() => setLoader(false))}>
                      <Search />
                    </button>
                  }
                />
              </FormGroup>
            </GridItem>
          </GridWrapper>
          {blData && blData.blSiteInfo && blData.blSiteInfo.length > 0 ? (
            <div className="table-scrollable">
              <Table
                rowKey="orderedLine.sku"
                data={blData.blSiteInfo}
                caption="Branch Locator Data"
                visuallyHiddenCaption
                columns={[
                  {
                    name: 'VerisaeSiteID',
                    className: 'customCol',
                    accessor: (data: BLType) => ({ value: data.verisaeSiteID, row: data }),
                    render: ({ value, row }: { value: string, row: BLType }) => (
                      <span
                        onClick={() => handleSelectedSite(row.verisaeSiteID, row.siteName)} // 👈 pass the identifier
                        style={{ cursor: 'pointer' }}
                      >
                        {value}
                      </span>
                    ),
                  },
                  {
                    name: 'SiteName',
                    className: 'customCol',
                    accessor: (data: BLType) => ({ value: data.siteName, row: data }),
                    render: ({ value, row }: { value: string, row: BLType }) => (
                      <span
                        onClick={() => handleSelectedSite(row.verisaeSiteID, row.siteName)} // 👈 pass the identifier
                        style={{ cursor: 'pointer' }}
                      >
                        {value}
                      </span>
                    ),
                  },
                  {
                    name: 'ParentSite',
                    className: 'customCol',
                    accessor: (data: BLType) => ({ value: data.parentSite, row: data }),
                    render: ({ value, row }: { value: string, row: BLType }) => (
                      <span
                        onClick={() => handleSelectedSite(row.verisaeSiteID, row.siteName)} // 👈 pass the identifier
                        style={{ cursor: 'pointer' }}
                      >
                        {value}
                      </span>
                    ),
                  },
                  {
                    name: 'FMRegion',
                    className: 'customCol',
                    accessor: (data: BLType) => ({ value: data.fmRegion, row: data }),
                    render: ({ value, row }: { value: string, row: BLType }) => (
                      <span
                        onClick={() => handleSelectedSite(row.verisaeSiteID, row.siteName)} // 👈 pass the identifier
                        style={{ cursor: 'pointer' }}
                      >
                        {value}
                      </span>
                    ),
                  },
                  {
                    name: 'FMZone',
                    className: 'customCol',
                    accessor: (data: BLType) => ({ value: data.fmZone, row: data }),
                    render: ({ value, row }: { value: string, row: BLType }) => (
                      <span
                        onClick={() => handleSelectedSite(row.verisaeSiteID, row.siteName)} // 👈 pass the identifier
                        style={{ cursor: 'pointer' }}
                      >
                        {value}
                      </span>
                    ),
                  },
                  {
                    name: 'DetailedType',
                    className: 'customCol',
                    accessor: (data: BLType) => ({ value: data.detailedType, row: data }),
                    render: ({ value, row }: { value: string, row: BLType }) => (
                      <span
                        onClick={() => handleSelectedSite(row.verisaeSiteID, row.siteName)} // 👈 pass the identifier
                        style={{ cursor: 'pointer' }}
                      >
                        {value}
                      </span>
                    ),
                  },
                  {
                    name: 'Refrigeration + M&E Supplier',
                    className: 'customCol',
                    accessor: (data: BLType) => ({ value: data.mer, row: data }),
                    render: ({ value, row }: { value: string, row: BLType }) => (
                      <span
                        onClick={() => handleSelectedSite(row.verisaeSiteID, row.siteName)} // 👈 pass the identifier
                        style={{ cursor: 'pointer' }}
                      >
                        {value}
                      </span>
                    ),
                  },
                ]}
              />
            </div>
          ) : (
            <div className="table-no-data">
              No data available
            </div>
          )}
        </Card>
        {
          (loader === true) && (<div className='loader'></div>)
        }
        {/* <Footer className="footer-fixed"> */}
        <Pagination
          className="footer-fixed"
          showFirstAndLast
          showPages
          current={currentPage}
          total={totalRecords ? Math.ceil(totalRecords / recordsPerPage) : 1}
          onChange={(page: number) => {
            setCurrentPage(page);
            callBranchLocatorData(page - 1, recordsPerPage)
          }}
        />
      </div>
      {/* </Footer> */}
      <Modal
        // small
        alert
        hideCloseButton
        open={isOpen}
        headingId="dialog-modal"
        style={{ display: 'flex', justifyContent: 'center', textAlign: 'left' }}
      >
        <GridItem size="1" className="ln-u-hard">
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
            <div style={{ display: 'grid', gridTemplateColumns: '150px 150px', gap: '10px' }}>
              <div><b style={{ fontWeight: '800' }}>Parent Site </b></div><div>: {selectedSite && selectedSite[0]?.parentSite ? selectedSite[0]?.parentSite : 'N/A'}</div>
              <div><b style={{ fontWeight: '800' }}>FM Region </b></div><div>: {selectedSite && selectedSite[0]?.fmRegion ? selectedSite[0]?.fmRegion : 'N/A'}</div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '150px 150px', gap: '10px' }}>
              <div><b style={{ fontWeight: '800' }}>Head of FM </b></div><div>: {selectedSite && selectedSite[0]?.headOfFMName ? selectedSite[0]?.headOfFMName : 'N/A'} </div>
              <div><b style={{ fontWeight: '800' }}>Business Partner </b></div><div>: {selectedSite && selectedSite[0]?.businesParner ? selectedSite[0]?.businesParner : 'N/A'} </div>
            </div>
          </div>
        </GridItem>
        <GridItem size={{default : '1'}}><></></GridItem>
        <div className="popup-table-scrollable">
        <Table
          style={{ marginLef: '-15px' }}
          rowKey="orderedLine.sku"
          data={selectedSite ? selectedSite : []}
          // caption="Branch Locator Data"
          visuallyHiddenCaption
          columns={[
            {
              name: 'Delivery Manager',
              className: 'customCol',
              accessor: (data: BranchLocatorUserInfo) => ({ value: data.deliveryManager ? data.deliveryManager : 'NA' }),
            },
            {
              name: 'Type Names',
              className: 'customCol',
              accessor: (data: BranchLocatorUserInfo) => ({ value: data.typeNames ? data.typeNames : 'NA' }),
            },
            {
              name: 'Area Name',
              className: 'customCol',
              accessor: (data: BranchLocatorUserInfo) => ({ value: data.areaName ? data.areaName : 'NA' }),
            },
          ]}
          />
          </div>
        <GridItem size={{xl:'1'}}></GridItem>
        <FilledButton style={{ float: 'right', marginTop: '20px' }} onClick={() => {
          setIsOpen(false);
          setUrl("")
        }}>
          Close
        </FilledButton>
        {url.length > 0 && (
          <BreadcrumbsWrapper narrow className="breadcrumb">
            {/* <BreadcrumbsItem> */}
            <Link to={url} target={'_blank'}>Store Locator</Link>
            {/* </BreadcrumbsItem> */}
          </BreadcrumbsWrapper>
        )}
      </Modal>
    </>
  );
};

export default BranchLocator;

